"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Provider = void 0;
var react_intl_1 = require("react-intl");
var react_1 = __importDefault(require("react"));
var lodash_merge_1 = __importDefault(require("lodash.merge"));
var baurde_1 = __importDefault(require("./locales/baurde"));
var imwalkingde_1 = __importDefault(require("./locales/imwalkingde"));
var quellede_1 = __importDefault(require("./locales/quellede"));
var quellech_1 = __importDefault(require("./locales/quellech"));
var quelleat_1 = __importDefault(require("./locales/quelleat"));
var ottoversandat_1 = __importDefault(require("./locales/ottoversandat"));
var universalat_1 = __importDefault(require("./locales/universalat"));
var ackermannch_1 = __importDefault(require("./locales/ackermannch"));
var jelmolich_1 = __importDefault(require("./locales/jelmolich"));
var default_1 = __importDefault(require("./locales/default"));
var index_1 = __importDefault(require("../../../hooks/useConfig/index"));
var tenantLocales = {
    baurde: baurde_1.default,
    imwalkingde: imwalkingde_1.default,
    quellede: quellede_1.default,
    quellech: quellech_1.default,
    quelleat: quelleat_1.default,
    ottoversandat: ottoversandat_1.default,
    universalat: universalat_1.default,
    ackermannch: ackermannch_1.default,
    jelmolich: jelmolich_1.default,
    emma: default_1.default,
    default: default_1.default,
};
var Provider = function (_a) {
    var _b, _c;
    var intl = _a.intl, children = _a.children, companyid = _a.companyid;
    var config = index_1.default();
    var locale = intl.locale, messages = intl.messages;
    var providerMessages = lodash_merge_1.default(messages, tenantLocales["" + (companyid || ((_c = (_b = config === null || config === void 0 ? void 0 : config.global) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.FRAGMENT_COMPANYID))]["" + locale] || {});
    return (react_1.default.createElement(react_intl_1.IntlProvider, { defaultLocale: "en", key: intl.locale, locale: intl.locale, messages: providerMessages }, children));
};
exports.Provider = Provider;
exports.default = react_intl_1.injectIntl(exports.Provider);
//# sourceMappingURL=index.js.map